export default __webpack_public_path__ + "static/logo-3dd320502128e74ada7f8ca10f0efab2.png";